import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MainMenuComponent } from '@features/navigation/desktop/main-menu/main-menu.component';
import { MetaMenuComponent } from '@features/navigation/desktop/meta-menu/meta-menu.component';
import { MobileMenuComponent } from '@features/navigation/mobile/mobile-menu/mobile-menu.component';
import { MobileMetaMenuComponent } from '@features/navigation/mobile/mobile-meta-menu/mobile-meta-menu.component';
import { MobileRootListComponent } from '@features/navigation/mobile/mobile-root-list/mobile-root-list.component';
import { MobileSubListComponent } from '@features/navigation/mobile/mobile-sub-list/mobile-sub-list.component';
import { SortByColumn } from '@features/navigation/mobile/mobile-sub-list/sort-by-column.pipe';
import { SharedModule } from '@shared/shared.module';

import { MainMenuGroupComponent } from './desktop/main-menu-group/main-menu-group.component';
import { SideAlignmentPipe } from './desktop/main-menu/side-alignment.pipe';

@NgModule({
    imports: [CommonModule, RouterModule, SharedModule, MainMenuComponent,
        MainMenuGroupComponent,
        MetaMenuComponent,
        MobileMenuComponent,
        MobileRootListComponent,
        MobileSubListComponent,
        MobileMetaMenuComponent,
        SortByColumn,
        SideAlignmentPipe],
    exports: [MainMenuComponent, MetaMenuComponent, MobileMenuComponent]
})
export class NavigationModule {}
